// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Trans } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
const TZ_OFFSET = (() => {
  const offsetMinutes = -new Date().getTimezoneOffset();
  const h = Math.trunc(offsetMinutes / 60);
  return `${h >= 0 ? "+" : "-"}${String(Math.abs(h)).padStart(2, "0")}`;
})();

export function TimezoneFooterNote() {
  return (
    <Trans
      i18nKey="dataTable.allTimesIn"
      ns="back-office"
      components={{
        tz: (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="cursor-help underline decoration-dotted underline-offset-2">{TZ}</span>
            </TooltipTrigger>
            <TooltipContent side="right">{`UTC${TZ_OFFSET}`}</TooltipContent>
          </Tooltip>
        ),
      }}
    />
  );
}
